import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import cn from 'classnames';
import styles from './index.module.scss';

const MessageResponse = ({
  toggleModal,
  toggleReply,
  toggleFwd,
  showOrHideReply,
}) => {
  const onReply = () => {
    toggleReply();
    toggleModal();
  };

  const onForward = () => {
    toggleFwd();
    toggleModal();
  };

  return (
    <div className={cn(styles.action, styles.operationalViewButton)}>
      <div className={cn(styles.action, styles.actionButton)}>
        <Button
          type="button"
          onClick={onForward}
          text={'Forward'}
          size="auto"
          color="primary"
        />
      </div>
      <div className={cn(styles.action, styles.actionButton)}>
        {showOrHideReply && (
          <Button
            type="button"
            text={'Reply'}
            onClick={onReply}
            size="auto"
            color="primary"
          />
        )}
      </div>
    </div>
  );
};

MessageResponse.propTypes = {
  editMode: PropTypes.bool,
  toggleEditMode: PropTypes.func,
  toggleModal: PropTypes.func,
  toggleReply: PropTypes.func,
  toggleFwd: PropTypes.func,
  showOrHideReply: PropTypes.bool,
};

export default MessageResponse;
